import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "./scss/index.scss";
import { Slider } from "@temp/@next/components/atoms/Slider";
import classNames from "classnames";
import React, { useMemo, useState } from "react";
import { useIntl } from "react-intl";
import ReactSVG from "react-svg";
import { Button, Overlay } from "../..";
import closeImg from "../../../images/x.svg";
import { commonMessages } from "../../../intl";
export function CustomTrackModal(_ref) {
  var overlay = _ref.overlay;
  var intl = useIntl();
  var _overlay$context$data = overlay.context.data,
      attribute = _overlay$context$data.attribute,
      onChange = _overlay$context$data.onChange,
      value = _overlay$context$data.value,
      defaultValue = _overlay$context$data.defaultValue,
      minValue = _overlay$context$data.minValue,
      maxValue = _overlay$context$data.maxValue;
  var filteredAttributeValues = useMemo(function () {
    return attribute.values.filter(function (_value) {
      return Number(_value.slug) >= Number(minValue) && Number(_value.slug) <= Number(maxValue);
    });
  }, [attribute, minValue, maxValue]);

  var _useState = useState(value),
      _useState2 = _slicedToArray(_useState, 2),
      innerValue = _useState2[0],
      setInnerValue = _useState2[1];

  var edgeValues = useMemo(function () {
    var sorted = filteredAttributeValues.sort(function (a, b) {
      return parseInt(a.slug, 10) - parseInt(b.slug, 10);
    });
    var max = parseInt(sorted[sorted.length - 1].slug, 10) / 10;
    var min = parseInt(sorted[0].slug, 10) / 10;
    return {
      max: max,
      min: min
    };
  }, [attribute]);

  var handleChange = function handleChange(newValue) {
    setInnerValue(newValue);
  };

  var handleReset = function handleReset() {
    setInnerValue(defaultValue);
  };

  return React.createElement(Overlay, {
    context: overlay
  }, React.createElement("div", {
    className: "custom-track-modal"
  }, React.createElement(ReactSVG, {
    path: closeImg,
    onClick: overlay.hide,
    className: "custom-track-modal__close-icon"
  }), React.createElement("div", {
    className: "custom-track-modal__title"
  }, intl.formatMessage(_defineProperty({
    defaultMessage: "Select custom rail size",
    "id": "components.OverlayManager.CustomTrackModal.CustomTrackModal.211678772"
  }, "id", "components.OverlayManager.CustomTrackModal.CustomTrackModal.211678772"))), React.createElement("div", {
    className: "custom-track-modal__body"
  }, React.createElement("div", {
    className: "custom-track-modal__row"
  }, React.createElement("div", {
    className: "custom-track-modal__slider-wr"
  }, React.createElement("div", {
    className: classNames("custom-track-modal__edge-values", "min", {
      active: edgeValues.min === innerValue / 10
    })
  }, edgeValues.min, " cm"), React.createElement(Slider, {
    values: filteredAttributeValues,
    onChange: handleChange,
    value: innerValue
  }), React.createElement("div", {
    className: classNames("custom-track-modal__edge-values", "max", {
      active: edgeValues.max === innerValue / 10
    })
  }, edgeValues.max, " cm")), React.createElement("button", {
    className: "custom-track-modal__reset",
    type: "button",
    onClick: handleReset
  }, intl.formatMessage(_defineProperty({
    defaultMessage: "reset to default",
    "id": "components.OverlayManager.CustomTrackModal.CustomTrackModal.3236844099"
  }, "id", "components.OverlayManager.CustomTrackModal.CustomTrackModal.3236844099")))), React.createElement("span", {
    className: "custom-track-modal__message"
  }, attribute.getMessage && attribute.getMessage(value)), React.createElement("div", {
    className: "custom-track-modal__row custom-track-modal__row-buttons"
  }, React.createElement(Button, {
    className: "cancel",
    onClick: overlay.hide
  }, React.createElement("span", null, intl.formatMessage(commonMessages.cancel))), React.createElement(Button, {
    className: "red",
    onClick: function onClick() {
      onChange(String(innerValue));
      overlay.hide();
    }
  }, React.createElement("span", null, intl.formatMessage(commonMessages.save)))))));
}